export const TOUR_OPERATOR = 'TOUR_OPERATOR';
export const REPLACEMENT = "REPLACEMENT";
export const CORPORATE ="CORPORATE";
export const RETAIL = "RETAIL";
export const SUBSCRIPTION = "SUBSCRIPTION";
export const UNDEFINED = "UNDEFINED";